module.exports = __webpack_public_path__ + "img/1440.7d28784d.jpg";